import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  total: 0,
};

const widgetsSlice = createSlice({
  name: "widgets",
  initialState,
  reducers: {
    setWidgetList: (state, action) => {
      state.list = action.payload?.message || [];
      state.total = action.payload?.result_number || 0;
    },
  },
});

export const { actions } = widgetsSlice;
export const { setWidgetList } = actions;

// selectors

export const selWidgetList = (state) => state.widgets.list;
export const selWidgetTotal = (state) => state.widgets.total;

const reducer = {
  widgets: widgetsSlice.reducer,
};

export default reducer;
